import { render, staticRenderFns } from "./tenantPackage.vue?vue&type=template&id=233f9a05&scoped=true"
import script from "./tenantPackage.vue?vue&type=script&lang=js"
export * from "./tenantPackage.vue?vue&type=script&lang=js"
import style0 from "./tenantPackage.vue?vue&type=style&index=0&id=233f9a05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233f9a05",
  null
  
)

export default component.exports